<template>
  <!--svg viewBox="0 0 32 32" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <g :transform='`rotate(${a} 16 16)`'>
      <path
        stroke="#fff"
        id="svg_0"
        d="m15.99654,4.49942c1.26261,0.00152 2.46881,0.20925 3.61113,0.5563l-0.90407,1.4858l6.41741,0l-1.60476,-2.64092l-1.60354,-2.64013l-0.84412,1.39118c-1.58201,-0.5496 -3.28747,-0.85719 -5.07091,-0.85719c-8.20905,0 -14.86274,6.32299 -14.86274,14.12351c0,3.23747 1.15877,6.212 3.08723,8.5952l2.25996,-1.64884c-1.55968,-1.92596 -2.49745,-4.32928 -2.50253,-6.94558c0.01136,-6.30662 5.38088,-11.40967 12.01694,-11.41934l0,0l0,0.00001zm11.77708,2.82633l-2.25995,1.64963c1.55929,1.92522 2.49706,4.32703 2.50135,6.94411c-0.01136,6.30657 -5.38088,11.40888 -12.01733,11.41928c-1.17602,-0.00144 -2.3011,-0.18315 -3.37367,-0.48703l0.85076,-1.39792l-6.41739,0l1.60358,2.63946l1.60473,2.6431l0.89466,-1.47533c1.51734,0.50194 3.14127,0.78197 4.83733,0.7827c8.21023,-0.00145 14.86279,-6.32445 14.86471,-14.12497c-0.00193,-3.23747 -1.16153,-6.21127 -3.08878,-8.59301l0,0l0,-0.00002z"
        :fill="color"
        :color="color"
        stroke-width="0"/>
    </g>
  </svg-->
  <svg viewBox="0 0 32 32" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <g :transform="`rotate(${a} 16 16)`">
      <ellipse
        v-for="p in points"
        v-bind:key="p.index"
        :opacity="p.opacity"
        :id="`svg_${p.index}`"
        :rx="p.r" :ry="p.r"
        :cx="p.x" :cy="p.y"
        :stroke="color"
        :fill="color"/>
    </g>
  </svg>
</template>

<script>

export default {
  name: 'LoaderSVG',
  props: {
    rx: {type: String, default: "8"},
    color: {type: String, default: "black"},
    period: {type: Number, default: 1},
  },
  data: function() {
    return {
      a: 5,
    }
  },
  created: function() {
    const count = 23;
    const skip = 3;
    const r = 12.24;
    const c = {x: 16, y: 16}
    this.points = [];
    for (let i = 0; i < count - skip; ++i) {
      const point = {
        index: i,
        x: c.x + r * Math.cos(2*Math.PI/count * i),
        y: c.y + r * Math.sin(2*Math.PI/count * i),
        r: 15-r,
        opacity: Math.pow((i + 1)/(count-skip), 2),
      }
      this.points.push(point);
    }
  },
  mounted: function() {
    this.startedAt = Date.now();
    this.h = setInterval(() => {
      const period = this.period * 1000;
      const now = Date.now();
      const elapsed = now - this.startedAt;
      this.a = elapsed/(period) * 360;
      if (elapsed >= period) {
        this.startedAt += period;
      }

    }, 15);
  },
  destroyed: function() {
    clearTimeout(this.h);
  }
}
</script>

<style scoped lang="scss">

svg {
  //border: 1px solid red;
  position: relative;
  top: 8px;
  padding: 2px;
}

</style>
